import { FC, MouseEvent } from 'react';
import { CheckCircle2 } from 'lucide-react';

import { Checkbox } from '@new/common/ui/Checkbox/Checkbox';

const REQUESTED_LABEL = 'Requested';
const NOT_REQUESTED_LABEL = 'Not requested';

interface OfficialTranscriptCellProps {
  requested: boolean;
  editable: boolean;
  disabled: boolean;
  onToggle: (requested: boolean) => void;
}

export const OfficialTranscriptCell: FC<OfficialTranscriptCellProps> = ({
  requested,
  editable,
  disabled,
  onToggle,
}) => {
  // The row itself opens the transcript, so a click on the checkbox must not reach it.
  const onCellClick = (event: MouseEvent) => {
    event.stopPropagation();
  };

  if (editable) {
    return (
      <div className="flex items-center justify-center gap-2" onClick={onCellClick}>
        <Checkbox value={requested} onChange={onToggle} disabled={disabled} variant="small" />
        <span className="[font-size:var(--fs-l5)]! text-(--neutral-black-NB1000)!">
          {requested ? REQUESTED_LABEL : NOT_REQUESTED_LABEL}
        </span>
      </div>
    );
  }

  if (requested) {
    return (
      <div className="flex items-center justify-center gap-2">
        <CheckCircle2 className="size-4! text-(--success-S700)" />
        <span className="[font-size:var(--fs-l5)]! text-(--neutral-black-NB1000)!">
          {REQUESTED_LABEL}
        </span>
      </div>
    );
  }

  return (
    <span className="[font-size:var(--fs-l5)]! text-(--neutral-black-NB700)!">
      {NOT_REQUESTED_LABEL}
    </span>
  );
};
